module.exports = __webpack_public_path__ + "img/bg_u.9608a965.png";